<template>
    <div v-loading="loading">
        <h3 style="text-align:center;">{{ $t('reports.rebateTypeSalesTitle') }}</h3>
        <div id="chartByRebateType" style="height:400px;width:400px;margin:auto;">
        </div>
        <el-table v-if="showTable"
            :data="summarizedData"
            stripe
            height="400"
            sum-text="Total"
            class="card-shadow--small"
            v-show="summarizedData &&  summarizedData.length || loading === false"
            :default-sort = "{prop: 'value', order: 'descending'}"
            show-summary
            style="width: 100%">
            <el-table-column
            prop="name"
            :label="$t('reports.rebateTypeLabel')"
            sortable
            width="180">
            </el-table-column>
            <el-table-column
                prop="value"
                sortable
                :label="$t('sales_orders.rebate')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
        </el-table>
</div>
</template>
<script>

import * as echarts from 'echarts';
import salesAPI from '@/services/API/sales'
import portausUtils from '@/utils/portaus-utils';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'SalesByTerritory',
    props: {
        showTable: {
        type: Boolean,
        default: false
        },
        filters: Object,
        type: {
            type: String,
            default: 'VALUE'
        },
        max: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            loading: true,
            data: [],
        }
    },
    components: {
    },
    watch: {
        type: function (val) {
            this.initChart();
        },
        filters: function (val) {
           this.init();
        }
    },
    methods: {
        formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
        formatNumber(amount) {
            return portausUtils.formatNumber(amount, this.$i18n.locale);
        },
        init() {
            this.loading = true;
            if (this.filters.inventoryId == null) return null;
            this.getSalesByRebateTypes(this.filters)
                .then((data) => {
                    
                    _.forEach(data, d => {
                        d.name = _.get(_.find(this.rebate_types, r => r.id === parseInt(d.credit_type)), 'name');
                        if (d.name == null) {
                            d.name = '--'
                        }
                    })

                    this.data = data;
                    
                    this.initChart();
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                })
        },
        getSalesByRebateTypes (filters) {
            return salesAPI.getSalesByRebateTypes(filters);
        },
        initChart () {
            this.chart = echarts.init(document.getElementById('chartByRebateType'));
            this.chart.setOption({
                title: {
                    show:false,
                    text: "Ventes par type de rabais",
                    padding:0,
                    left:'center',
                    textAlign:'center'
                },
                tooltip: {
                    show:true,
                    trigger: 'item',
                    appendToBody: true,
                },
                legend: {
                    show:false,
                    orient: 'vertical',
                    left: 'left',
                    selectedMode: false,
                },
                series: [
                    {
                        // name: 'Ventes / Type.',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                        },
                        label: {
                            show: true,
                            overflow: 'break',
                            width: 75,
                        },
                        labelLine: {
                            show: true
                        },
                        data: this.chartData,
                    }
                ]
            });
            this.chart.on('click', (params) => this.$emit('change', params.data));
        },
        ...mapActions('controlData', ['fetchRebateTypes']),
    },
    computed : {

        chartData () {
            return _.map(this.dataByType, data => ({ id: data.id, value: data.value, name: `${data.name}`, tooltip: { valueFormatter: (value) => !this.isQuantityBased ?  '$' + value : value }}))
        },
        dataByType() {
            return this.dataByRebate;   
        },
        summarizedData () {
            if (this.max >= 0) {
                return _.slice(this.dataByType, 0, this.max);
            } else {
                return this.dataByType;
            }
           
        },
        dataByRebate () {
            return _.orderBy(_.map(this.data, d => ({id: d.credit_type, name: d.name, value: Number(d.discount), valueOrder: Number(d.discount)})), ['valueOrder'], ['desc']);
        },
        ...mapState('controlData', ['rebate_types']),
    },
    mounted() {
        this.fetchRebateTypes()
            .then(() => {
                this.init();
            })
    }
   
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
  